import { requests } from './requests';
import {
  BASELINKS as BASE_LINKS,
} from './webSiteLanguages';

export const ADDRESSES = {
  us: [
    {
      code: 'us',
      country: 'ct_us',
      city: 'city_la_us',
      address1: false,
      address2: false,
      position: { top: 18, left: 22.5 },
    },
  ],
  pt: [
    {
      code: 'pt',
      country: 'ct_pt',
      city: 'city_la_pt',
      address1: 'Campo 24 de Agosto',
      address2: 'Nº 129, Floor 7, Office 701',
      position: { top: 23, left: 40 },
    },
  ],
  ng: [
    {
      code: 'ng',
      country: 'ct_ng',
      city: 'city_la_ng',
      address1: 'Oko Awo Street',
      address2: 'Victoria Island',
      position: { top: 47, left: 43 },
    },
  ],
  pl: [
    {
      code: 'pl',
      country: 'ct_pl',
      city: 'city_la_pl',
      address1: 'WeWork Hotel Europejski',
      address2: '13 Krakowskie Przedmieście',
      position: { top: 16, left: 47 },
    },
  ],
  cz: [
    {
      code: 'cz',
      country: 'ct_cz',
      city: 'city_la_cz',
      address1: 'Panská 854/2',
      address2: 'Nové Město, Praha 1',
      position: { top: 17, left: 45 },
      ic: '08796386',
      dic: 'CZ08796386',
      phone: '+420 778 955 884',
      email: {
        to: 'czech@lidya.info',
        subject: 'web.header.contact.email.subject',
      },
    },
  ],
};

export const SOCIAL = {
  us: [
    {
      icon: 'twitter',
      link: 'https://twitter.com/Lidya_Finance',
    },
    {
      icon: 'instagram',
      link: 'https://www.instagram.com/lidya_finance/',
    },
    {
      icon: 'linkedin',
      link: 'https://www.linkedin.com/company/lidyadotco',
    },
    {
      icon: 'facebook',
      link: 'https://www.facebook.com/Lidya-105756085188427',
    },
  ],
  pt: [
    {
      icon: 'twitter',
      link: 'https://twitter.com/Lidya_Finance',
    },
    {
      icon: 'instagram',
      link: 'https://www.instagram.com/lidya_finance/',
    },
    {
      icon: 'linkedin',
      link: 'https://www.linkedin.com/company/lidyadotco',
    },
    {
      icon: 'facebook',
      link: 'https://www.facebook.com/Lidya-105756085188427',
    },
  ],
  ng: [
    {
      icon: 'twitter',
      link: 'https://twitter.com/Lidya_Finance',
    },
    {
      icon: 'instagram',
      link: 'https://www.instagram.com/lidya_finance/',
    },
    {
      icon: 'linkedin',
      link: 'https://www.linkedin.com/company/lidyadotco',
    },
    {
      icon: 'facebook',
      link: 'https://www.facebook.com/Lidya-105756085188427',
    },
  ],
  pl: [
    {
      icon: 'twitter',
      link: 'https://twitter.com/Lidya_Finance',
    },
    {
      icon: 'instagram',
      link: 'https://www.instagram.com/lidya_finance/',
    },
    {
      icon: 'linkedin',
      link: 'https://www.linkedin.com/company/lidyadotco',
    },
    {
      icon: 'facebook',
      link: 'https://www.facebook.com/Lidya-Polska-103155735536295',
    },
  ],
  cz: [
    {
      icon: 'twitter',
      link: 'https://twitter.com/Lidya_Finance',
    },
    {
      icon: 'instagram',
      link: 'https://www.instagram.com/lidya_finance/',
    },
    {
      icon: 'linkedin',
      link: 'https://www.linkedin.com/company/lidyadotco',
    },
    {
      icon: 'facebook',
      link: 'https://www.facebook.com/Lidya-Czech-107554088357446',
    },
  ],
};

const LIDYABUSINESSVALUES = {
  time: 1570453900158,
  countries: 3,
  partners: 78,
  loans: 9385,
  business: 200115,
};

export const getBusinessValues = () => {
  const {
    time: lTime,
    countries,
    partners,
    loans,
    business,
  } = LIDYABUSINESSVALUES;
  const nTime = Date.now();
  const difference = nTime - lTime;
  const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  const hoursDifference = Math.floor(difference / 1000 / 60 / 60);
  const minutesDifference = Math.floor(difference / 1000 / 60);
  const nBusiness = Math.floor(minutesDifference / 15) + business;
  const nLoans = Math.floor(hoursDifference * 2) + loans;
  const nPartners = Math.floor(daysDifference / 60) + partners;

  return {
    business: nBusiness,
    loans: nLoans,
    partners: nPartners,
    countries,
  };
};

getBusinessValues();

export const BASELINKS = BASE_LINKS;

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g;

export const YEARS = () => {
  const years = [];
  const date = new Date();
  const lastYear = date.getFullYear() - 18;
  let startYear = date.getFullYear() - 68;
  while (startYear <= lastYear) {
    years.push({ value: startYear++ });
  }
  return years;
};

const COUNTRIES = {};
export let LOCATIONS = [];
const setCountriesAndLocations = () => new Promise((resolve) => {
  requests.getLocationsList().then((locations) => {
    LOCATIONS = locations;
    if (Object.keys(COUNTRIES).length < 1) {
      locations.map((location) => {
        COUNTRIES[location.code] = location.name;
        resolve(locations);
      });
    } else {
      resolve(locations);
    }
  });
});

setCountriesAndLocations().then(() => {});

export const getCountryByCode = (code) => new Promise((resolve) => {
  if (LOCATIONS.length > 0) {
    const country = COUNTRIES[code];
    resolve(country || 'N/A');
  } else {
    setCountriesAndLocations().then(() => {
      const country = COUNTRIES[code];
      resolve(country || 'N/A');
    });
  }
});

let CATEGORIES = [];
export const getCategories = () => new Promise((resolve) => {
  if (CATEGORIES.length > 0) {
    resolve(CATEGORIES);
  } else {
    requests.getCategories().then((categories) => {
      CATEGORIES = categories;
      resolve(CATEGORIES);
    });
  }
});

export const getCategoriesByCode = (code) => new Promise((resolve) => {
  getCategories().then(() => {
    const object = CATEGORIES.filter((category) => category.code === code);
    const value = object[0] ? object[0].name : 'N/A';
    resolve(value);
  });
});
